import TemplatesACHPage from "components/pages/TemplatesACHPage"

export default function CaptureACHTemplates(props) {
    return <TemplatesACHPage/>;
}